import { toast as rToast } from "react-toastify";

export const toast = {
  success: (msg) => {
    rToast.dismiss();
    return rToast.success(msg);
  },
  error: (msg) => {
    rToast.dismiss();
    return rToast.error(msg);
  }
};
